import { render, staticRenderFns } from "./tiggerInfo.vue?vue&type=template&id=c1f14450&scoped=true"
import script from "./tiggerInfo.vue?vue&type=script&lang=js"
export * from "./tiggerInfo.vue?vue&type=script&lang=js"
import style0 from "./tiggerInfo.vue?vue&type=style&index=0&id=c1f14450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f14450",
  null
  
)

export default component.exports